import React, {useRef} from 'react';
import {Button} from '@mui/material';

type InputFileProps = {
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  variant?: 'contained' | 'outlined' | 'text';
};

const InputFile = ({onFileSelect, label, variant = 'contained'}: InputFileProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <div>
      <input hidden type="file" ref={fileInputRef} onChange={onFileSelect} />
      <Button
        variant={variant}
        onClick={(e) => {
          e.preventDefault();
          fileInputRef.current?.click();
        }}
      >
        {label}
      </Button>
    </div>
  );
};

export default InputFile;
